export default "__VITE_ASSET__5a73ca94__"